import ar_white from "../../assets/images/Introduction/ar_white.svg";
import home_white from "../../assets/images/Introduction/home_white.svg";

import intro_mobi from "../../assets/images/Introduction/intro_mobi.webp";
import intro_pc from "../../assets/images/Introduction/intro_pc.webp";

export default function IntroductionBanner() {
  return (
    <div className="w-full">
      <div className="w-full">
        <div
          className="block md:hidden lg:hidden w-full relative bg-center bg-cover bg-no-repeat"
          style={{
            backgroundImage: `url(${intro_mobi})`,
          }}
        >
          <div className="w-full bg-bggra1 ">
            <div className="w-full mx-auto flex flex-col gap-2 items-center justify-center pt-16 py-[20px] px-[20px]">
              <div className="w-full rounded-[40px] flex gap-1">
                <div className="flex items-center gap-2">
                  <img src={home_white} alt="home1" />
                  <img src={ar_white} alt="ar" />
                </div>
                <div>
                  <p className="text-[1rem] font-normal text-white whitespace-nowrap">
                    Giới thiệu
                  </p>
                </div>
              </div>
              <div className="w-full">
                <p className="text-[28px] font-semibold text-white">
                  BLUERISE - GIẢI PHÁP CHUYỂN ĐỔI SỐ TOÀN DIỆN
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          className="hidden md:block lg:block w-full relative h-[20rem] mt-1 bg-cover bg-no-repeat bg-center"
          style={{
            backgroundImage: `url(${intro_pc})`,
          }}
        >
          <div className="w-full mx-auto h-[20rem] bg-bggra1 ">
            <div className=" flex flex-col gap-2 items-center justify-center w-full mx-auto pt-20">
              <div className="w-full h-[2.625rem] rounded-[40px] flex items-center justify-center ">
                <div className="flex items-center gap-2">
                  <img src={home_white} alt="home1" />
                  <img src={ar_white} alt="ar" />
                </div>
                <div>
                  <p className="text-[1rem] font-normal text-white whitespace-nowrap">
                    Giới thiệu
                  </p>
                </div>
              </div>
              <div className="w-full text-center">
                <p className="text-[28px] font-semibold text-white">
                  BLUERISE - GIẢI PHÁP CHUYỂN ĐỔI SỐ TOÀN DIỆN
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
